import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SessionTimeoutModal from '../session-timeout-modal/SessionTimeoutModal';
import SessionTimeoutPageTitle from '../session-timeout-page-title/SessionTimeoutPageTitle';

export class SessionTimeoutWarning extends PureComponent {

  static propTypes = {
    sessionExpiringAnnounced: PropTypes.bool,
  };

  static defaultProps = {
    sessionExpiringAnnounced: false,
  };

  render() {
    const {
      sessionExpiringAnnounced,
    } = this.props;

    if (!sessionExpiringAnnounced) {
      return null;
    }

    return (
      <>
        <SessionTimeoutModal />
        <SessionTimeoutPageTitle />
      </>
    );
  }
}

export function mapStateToProps(state) {
  return {
    sessionExpiringAnnounced: state.app.sessionExpiringAnnounced,
  };
}

export default connect(state => mapStateToProps(state))(SessionTimeoutWarning);
